(function() {
  'use strict';

  function ObjConverter() {

    var ObjConverter = {};

    var models = {
      "encomenda": {
        "idImportacao": null,
        "destinatario": {
          "nome": null,
          "email": null,
          "cpf": null,
          "cnpj": null,
          "inscricaoEstadual": null,
          "endereco": {
            "cep": null,
            "bairro": null,
            "logradouro": null,
            "numero": null,
            "cidade": null,
            "estado": null,
            "complemento": null
          }
        },
        "observacao": null,
        "situacao": null,
        'chaveAcessoNfe': null,
        "numeroPedidoLoja": null,
        "tipoDocumentoOrigem": null,
        "referencia": null,
        "formaEnvio": {
          "codigo": null,
          "altura": null,
          "largura": null,
          "comprimento": null,
          "peso": null,
          "valorDeclarado": null,
          "avisoRecebimento": null,
          "maoPropria": null,
          "codigoRastreamento": null
        },
        "codigo": [{
          "codigo": null
        }]
      }
    };

    ObjConverter.encomenda = function(oldCollection) {

      var newCollection = [];

      newCollection = _.map(oldCollection, function(item) {
        var newItemCollection = {};
        newItemCollection = _.pick(item, ['destinatario', 'observacao', 'idImportacao']);
        newItemCollection = _.assignIn(angular.copy(models.encomenda), newItemCollection);
        newItemCollection.formaEnvio.codigo = item.frete.codigoMandae;
        newItemCollection.formaEnvio.valorDeclarado = item.frete.valorDeclarado || null;
        newItemCollection.formaEnvio.codigoRastreamento = item.frete.codigoRastreamento || null;
        newItemCollection.tipoDocumentoOrigem = 'NFe';
        newItemCollection.chaveAcessoNfe = item.notaFiscal && item.notaFiscal.chaveAcesso || null;
        return _.isObject(newItemCollection) ? newItemCollection : null;
      });

      return newCollection;

    };

    return ObjConverter;

  }

  angular
    .module('mandaeApp')
    .factory('ObjConverter', ObjConverter);

}());
